const carouselConfig = {
    carousel: {
        PAYMENT: 'Ask me anything',
        SERVICE_PROBLEMS: 'Service problems?',
        PODS: 'I work with your Xfinity services'

    }
}

export default carouselConfig;
